import { httpClient } from './api/httpClient';
import { isMockEnabled, mockResponse } from './api/mockAdapter';
import { API_ENDPOINTS } from 'constants/apiEndpoints';
import { BUNDLE_STATUS } from 'constants/status';
import { MOCK_STORAGE1, MOCK_BUNDLES } from 'mock/pipeline.mock';

export const toStorage1 = (raw) =>
  raw && {
    id: raw.id,
    routedFrom: raw.previous_stage?.stage ?? '',
    sourceModule: raw.workflow?.routing_destination ?? raw.source_module ?? raw.sourceModule ?? '',
    newspaperName: raw.newspaper_name ?? raw.newspaperName ?? '',
    edition: raw.edition ?? '',
    keyword: raw.keywords ?? raw.keyword ?? [],
    articleLink: raw.article_image_url ?? raw.article_link ?? raw.articleLink ?? '',
    newspaperLink: raw.newspaper_page_image_url ?? raw.newspaper_link ?? raw.newspaperLink ?? '',
    mergedPdfLink: raw.merged_pdf_url ?? raw.merged_pdf_link ?? raw.mergedPdfLink ?? null,
    mergeStatus: raw.merged_pdf_status ?? raw.merge_status ?? raw.mergeStatus ?? 'pending',
    bundleId: raw.bundle_id ?? raw.bundleId ?? null,
    pageNumber: raw.page_number ?? raw.pageNumber ?? null,
    status: raw.workflow?.status ?? raw.status ?? 'routed',
    workflow: raw.workflow ?? null,
    routing: raw.routing ?? null,
    createdAt: raw.created_at ?? raw.createdAt ?? null,
    isManualUpload: raw.is_manual_upload ?? false,
    source: raw.source?.type ?? raw.source ?? '',
    notes: raw.notes ?? null,
  };

export const toBundle = (raw) =>
  raw && {
    id: raw.id,
    bundleNumber: raw.bundle_number ?? raw.bundleNumber,
    newspaperName: raw.newspaper_name ?? raw.newspaperName ?? '',
    articleCount: raw.article_count ?? raw.articleCount ?? 0,
    bundledPdfLink: raw.bundled_pdf_link ?? raw.bundledPdfLink ?? null,
    excelSheetLink: raw.excel_sheet_link ?? raw.excelSheetLink ?? null,
    dispatchHistory: (raw.dispatch_history ?? raw.dispatchHistory ?? []).map((h) => ({
      dispatchedAt: h.dispatched_at ?? h.dispatchedAt,
      dispatchedTo: h.dispatched_to ?? h.dispatchedTo,
      requestedCount: h.requested_count ?? h.requestedCount,
      dispatchedBy: h.dispatched_by ?? h.dispatchedBy,
    })),
    status: raw.status,
    createdAt: raw.created_at ?? raw.createdAt ?? null,
  };

let articles = MOCK_STORAGE1.map((r) => ({ ...r }));
let bundles = MOCK_BUNDLES.map((r) => ({ ...r, dispatch_history: [...(r.dispatch_history || [])] }));

export const storage1Service = {
  async list(params = {}) {
    if (isMockEnabled()) {
      let filtered = articles;
      if (params.newspaper_name) {
        filtered = filtered.filter(a => a.newspaper_name === params.newspaper_name || a.newspaperName === params.newspaper_name);
      }
      const items = (await mockResponse(filtered)).map(toStorage1);
      return { items, total: items.length, page: 1, pageSize: items.length || 20, totalPages: 1 };
    }
    const data = await httpClient.get(API_ENDPOINTS.STORAGE1.LIST, { params });
    return {
      items: (Array.isArray(data) ? data : data.items ?? []).map(toStorage1),
      total: data.total ?? 0,
      page: data.page ?? 1,
      pageSize: data.page_size ?? 20,
      totalPages: data.total_pages ?? 0,
    };
  },

  async listBundles() {
    if (isMockEnabled()) return (await mockResponse(bundles)).map(toBundle);
    const data = await httpClient.get(API_ENDPOINTS.STORAGE1.BUNDLES);
    return (Array.isArray(data) ? data : data.items ?? []).map(toBundle);
  },

  async dispatch({ bundleIds, dispatchedTo, dispatchedBy }) {
    if (isMockEnabled()) {
      const ready = bundles.filter(b => bundleIds.includes(b.id));
      const ids = ready.map((b) => b.id);
      bundles = bundles.map((b) =>
        ids.includes(b.id)
          ? {
              ...b,
              status: BUNDLE_STATUS.DISPATCHED,
              dispatch_history: [
                ...b.dispatch_history,
                { dispatched_at: new Date().toISOString(), dispatched_to: dispatchedTo, requested_count: 1, dispatched_by: dispatchedBy },
              ],
            }
          : b
      );
      return (await mockResponse(bundles)).map(toBundle);
    }
    const data = await httpClient.post(API_ENDPOINTS.STORAGE1.DISPATCH, { bundle_ids: bundleIds, dispatch_to: [dispatchedTo] });
    return (Array.isArray(data) ? data : data.items ?? []).map(toBundle);
  },


};

export default storage1Service;
